import { useDebounce } from '@shared/composables/useDebounce'

export const useSearchThrottle = (searchValue, callback, debounceTime = 600) => {
  const condition = (value) => value.length >= 3 || value.length === 0

  useDebounce(searchValue, callback, debounceTime, condition)
}
